// @flow

import React from "react";

const SECONDS_PER_HOUR = 3600;

export type Props = $Exact<{
  value: string | number,
  required: boolean,
  options: Object,
  onChange: (value: number | string) => {},
}>;

export class SecondsAsHoursInput extends React.Component<Props> {
  toHours = (seconds: number | string) =>
    Number.parseFloat(
      Number.parseFloat((parseFloat(seconds) / SECONDS_PER_HOUR).toString()).toFixed(2),
    );

  toSeconds = (hours: string | number) => parseFloat(hours) * SECONDS_PER_HOUR;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    const value = this.props.value === 0 ? 0 : this.toHours(this.props.value) || null;

    return (
      <React.Fragment>
        <div className="schema-form-widget-seconds-as-hours-input position-relative">
          <input
            type="number"
            lang="en-EN"
            className="form-control"
            value={value}
            required={this.props.required}
            disabled={this.props.disabled}
            readOnly={this.props.readonly}
            onChange={this.handleChange}
          />
          <label className="position-absolute top-10 right-12">hours</label>
        </div>
      </React.Fragment>
    );
  }
}

export default SecondsAsHoursInput;
